import {APIMethod} from '@enums'

import {fetchData} from 'api/api'

import {CompanyResponse} from '../company/types'
import {ParentCompanyRequest, ParentCompanyResponse} from './types'

export const getAllParentCompanies = async (): Promise<ParentCompanyResponse[]> => {
  return fetchData({
    method: APIMethod.GET,
    url: 'parent-company',
  })
}

export const getParentCompanyById = async (id: string): Promise<ParentCompanyResponse> => {
  return fetchData({
    method: APIMethod.GET,
    url: `parent-company/${id}`,
  })
}

export const createParentCompany = async (body: ParentCompanyRequest): Promise<ParentCompanyResponse> => {
  return fetchData({
    method: APIMethod.POST,
    url: 'parent-company',
    body,
  })
}

export const updateParentCompany = async (id: string, body: ParentCompanyRequest): Promise<ParentCompanyResponse> => {
  return fetchData({
    method: APIMethod.PUT,
    url: `parent-company/${id}`,
    body,
  })
}

export const getLinkedCompanies = async (id: string): Promise<CompanyResponse[]> => {
  return fetchData({
    method: APIMethod.GET,
    url: `parent-company/${id}/linked-companies`,
  })
}
